import { PreguntaExportador } from "../PreguntaExportador";
import { FilasExcel, PreguntasTipoEnum } from "@shared/enums";
import { DatosEncuestaExportar } from "../DatosEncuestaExportar";
import { PreguntaDTO } from "@DTOS";

export class PreguntaRankingExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.RANKING;
    }

    protected generarFilaPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string> {
        const preguntaCambiada = new PreguntaDTO(datosEncuesta.pregunta.toJSON());
        preguntaCambiada.minimo = preguntaCambiada.minimoItemsSeleccionados;
        preguntaCambiada.maximo = preguntaCambiada.maximoItemsSeleccionados;
        return super.generarFilaPregunta({
            ...datosEncuesta,
            pregunta: preguntaCambiada
        });
    }
}
